import { useContext, useEffect } from 'react';
import Tabs from '../components/Tabs';
import { UserContext } from '../context/userContext';
import { TabItem } from '../interface/interface';
import PatientPrescriptions from './PatientPrescriptions';

export function PatientMedicationTabs() {
  const { setActiveItem } = useContext(UserContext);

  useEffect(() => {
    setActiveItem('My Care Hub');
  }, []);

  const tabs: Array<TabItem> = [
    {
      id: 'medications',
      label: 'Medications',
      component: <PatientPrescriptions />,
    },
  ];

  return <Tabs tabs={tabs} />;
}
